import React, {useState} from 'react';
import {Button, Dimmer, Form, Input, Loader, Modal, Segment} from "semantic-ui-react";
import {toast} from "react-toastify";
import {apiPost} from "../../services/apiClient";

const FieldModal = ({children, col, row, reload, label, withSync, InputComponent}) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState('');

    const onClose = () => {
        setLoading(false);
        setOpen(false);
    }

    const onOpen = () => {
        setOpen(true);
        (col && row) && setValue(row[col.fieldName]);
    }

    const onError = (err) => {
        setLoading(false);
        (err.error || err.message) && toast.error(err.error || err.message)
    }

    const callbackSuccess = () => {
        reload && reload();
        onClose();
    }

    const onSave = () => {
        setLoading(true)
        apiPost(`parcels/${row.id}/field`, {
            fieldName: col.fieldName,
            value
        }).then(() => {
            if (withSync) {
                apiPost(`parcels/${row.id}/syncDataCarrier`).then(res => {
                    if (res.getMessageChange) {
                        toast.info(res.getMessageChange, {autoClose: 20000})
                    }
                    callbackSuccess();
                }).catch(onError)
            } else {
                callbackSuccess();
            }
        }).catch(onError)
    }

    return (
        <Modal
            trigger={children}
            closeIcon
            onClose={onClose}
            onOpen={onOpen}
            open={open}
            size="tiny"
        >
            <Modal.Header>
                {label}
            </Modal.Header>

            <Segment vertical style={{borderBottom: 'none'}}>
                <Dimmer active={loading} inverted>
                    <Loader size='medium'/>
                </Dimmer>
                <Modal.Content className='modal__content'>
                    <Form>
                        <Form.Field>
                            <label>
                                {col.title}
                            </label>
                            {React.cloneElement(InputComponent ? <InputComponent/> : <Input />, {
                                value,
                                name: col.fieldName,
                                onChange: InputComponent ? setValue : (e, {value}) => setValue(value)
                            })}
                        </Form.Field>
                    </Form>
                </Modal.Content>
            </Segment>

            <Modal.Actions  className='modal__actions'>
                <Button onClick={onClose}>
                    Отмена
                </Button>
                <Button disabled={loading} onClick={onSave} className='modal__actions_yes'>
                    Сохранить
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default FieldModal;


// WEBPACK FOOTER //
// ./App/components/Modals/FieldModal.jsx